export default "/images/vendor/flag-icons/flags/1x1/ad.svg?e28ac34f6d66a12c1e677b233a067be2";